import { Snowplow2StatsDataTrackable } from './trackable';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsAdapterSchemaSearchContext } from '../adapter/schema-search-context';
import { Snowplow2StatsAdapterSchemaAgentSearchContext } from '../adapter/schema-agent-search-context';
import { Snowplow2StatsAdapterSchemaBrokerSearchContext } from '../adapter/schema-broker-search-context';
import { Snowplow2StatsAdapterSchemaAttributionContext } from '../adapter/schema-attribution-context';
import { Snowplow2StatsAdapterSchemaAuthContext } from '../adapter/schema-auth-context';

export class Snowplow2StatsDataSearch extends Snowplow2StatsDataTrackable {
  /**
   * @inheritDoc
   */
  constructor(context: StatsContextInterface) {
    super(context);

    // Property search context (optional)
    if (context.global.property_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaSearchContext(context).getData());
    }

    // Agent search context (optional)
    if (context.global.agent_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAgentSearchContext(context).getData());
    }

    // Broker search context (optional)
    if (context.global.broker_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaBrokerSearchContext(context).getData());
    }

    // Authentication context (optional)
    if (context.global.authentication.user) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAuthContext(context).getData());
    }

    if (context.global.authentication.attributionId) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAttributionContext(context).getData());
    }
  }
}
